<template>
  <div>
    <DeleteModal modalId="modal-emergency-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-emergency-edit"
      no-close-on-backdrop
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('emergency.add emergency')
          : $t('emergency.edit emergency')
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <!-- <AutoComplete
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              v-model="EditForm.patient_card_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              :otherQuery="`include=patient`"
            /> -->
            <AutoComplete
              v-model="EditForm.patient_card_id"
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              :otherQuery="`include=patient&filter[type]=EMERGENCY,IN&filter[is_active]=true`"
              keyword="patient"
            />
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('emergency.Diagnosis')"
              label-for="diagnosis"
            >
              <b-form-input
                id="diagnosis"
                v-model="EditForm.diagnosis"
                :placeholder="$t('emergency.Diagnosis')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('emergency.Investigation')"
              label-for="investigation"
            >
              <b-form-input
                id="investigation"
                v-model="EditForm.investigation"
                :placeholder="$t('emergency.Investigation')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('emergency.Examination')"
              label-for="examination"
            >
              <b-form-input
                id="examination"
                v-model="EditForm.examination"
                :placeholder="$t('emergency.Examination')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('emergency.Treatment')"
              label-for="treatment"
            >
              <b-form-input
                id="treatment"
                v-model="EditForm.treatment"
                :placeholder="$t('emergency.Treatment')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <b-card :title="$t('emergency.Add Emergency')">
      <!-- Search Patient Name -->
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h3>{{ $t("emergency.Filter Emergencies") }}</h3>
            <br />
          </b-col>

          <b-col md="6" cols="6">
            <AutoComplete
              v-model="patientFilter"
              :label="$t('common.Patient Card')"
              :placeholder="$t('common.Patient Card')"
              param-query="patient.name"
              :serializer="(val) => val.id"
              endpoint="patientCard"
              text-title="patient.name"
              :isRelational="true"
              :otherQuery="`include=patient&filter[type]=EMERGENCY,IN&filter[is_active]=true`"
              keyword="patient"
            />
          </b-col>
          <b-col
            cols="6"
            md="6"
            class="d-flex align-items-center justify-content-end mt-1"
          >
            <b-button variant="primary" @click="getEmergencies()">
              {{ $t("common.search") }}
              <!-- <b-icon-search class="ml-1"></b-icon-search> -->
            </b-button>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mt-2"
          >
            <!-- Create Emergency Button -->
            
              <b-col cols="12" class="d-flex justify-content-end mb-1">
                <b-button variant="success" @click="show({}, 'create')">
                  {{ $t("emergency.Create Emergency") }}
                </b-button>
              </b-col>
            
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h3>{{ $t("emergency.nursing-patient-with-emergency-in-patient-card") }}</h3>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(patient_card.is_active)="data">
            <span
              class="badge badge-pill"
              :class="
                data.item.patient_card.is_active
                  ? 'badge-success'
                  : 'badge-danger'
              "
            >
              {{ data.item.patient_card.is_active ? "Active" : "Inactive" }}
            </span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <!-- @click="printId(data.item.id)" -->
              <b-button
                pill
                variant="outline-warning"
                size="sm"
                class="mx-2"
                @click="
                  $router.push({
                    name: 'patient-emergency-info',
                    params: { id: data.item.patient_card_id },
                  })
                "
              >
                {{ $t("common.show-info") }}
              </b-button>

              <b-button
                class="button-preview"
                pill
                @click="
                  $router.push({
                    name: 'patient-card-history',
                    params: { id: data.item.patient_card.patient.id },
                  })
                "
                :variant="data.item.is_dead ? 'danger' : 'outline-secondary'"
              >
                {{ $t("reception.patient-history") }}
              </b-button>
              <ActionsButtons
                deletePerm="delete-emergency"
                editPerm="update-emergency"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Emergencies</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getEmergencies()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";

import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: "",
        investigation: "",
        diagnosis: "",
        examination: "",
        treatment: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        patient_card_id: "",
        investigation: "",
        diagnosis: "",
        examination: "",
        treatment: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "patient_card.patient.name",
          label: this.$t("common.name"),
          sortable: true,
        },
        {
          key: "diagnosis",
          sortable: true,
          label: this.$t("emergency.Diagnosis"),
        },
        {
          key: "investigation",
          sortable: true,
          label: this.$t("emergency.Investigation"),
        },
        {
          key: "treatment",
          sortable: true,
          label: this.$t("emergency.Treatment"),
        },
        {
          key: "patient_card.type",
          sortable: true,
          label: this.$t("emergency.card-type"),
        },
        {
          key: "patient_card.is_active",
          sortable: true,
          label: this.$t("common.card-id-status"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      patientFilter: "",
      surgeryFilter: "",
      priceFilter: "",
    };
  },
  mounted() {
    this.getEmergencies();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          patient_card_id: "",
          investigation: "",
          diagnosis: "",
          examination: "",
          treatment: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = item.patient_card_id;
        this.EditForm.investigation = item.investigation;
        this.EditForm.diagnosis = item.diagnosis;
        this.EditForm.examination = item.examination;
        this.EditForm.treatment = item.treatment;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-emergency-edit");
    },

    async getEmergencies() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/emergency?page=${this.page}&take=${this.take}&sort=-id&include=patientCard`;

      if (this.patientFilter) {
        url += `&filter[patient_card_id]=${this.patientFilter}`;
      }
      if (this.surgeryFilter) {
        url += `&filter[surgery_id]=${this.surgeryFilter}`;
      }
      if (this.priceFilter) {
        url += `&filter[price]=${this.priceFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-emergency-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/emergency/${this.deleteForm.id}`)
        .then((response) => {
          this.getEmergencies();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/emergency`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getEmergencies();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/emergency/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getEmergencies();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
